import React, { useState, useEffect } from 'react'
import { BreadcrumbProps } from '@blueprintjs/core'
import { axiosGet } from '../util/api'
import { useUser } from '../hooks/useUser'
import qs from 'qs'
import { Layout } from '../components/Layout'

export const Keys = ({}) => {
    const breadcrumbs: BreadcrumbProps[] = [{ text: 'Settings' }]

    return (
        <Layout breadcrumbs={breadcrumbs} primary="Amazon Ads Connection">
            <div className="max-w-3xl mx-auto">
                <KeysForm />
            </div>
        </Layout>
    )
}

export const KeysForm = ({ hideTitle = false }: { hideTitle?: boolean }) => {
    const { hasKeys, invalidKeys } = useUser()
    const [link, setLink] = useState('')
    const { message } = qs.parse(window.location.search.substr(1))

    useEffect(() => {
        axiosGet('keys/link')
            .then((res) => {
                setLink(res.data)
            })
            .catch((res) => {
                console.log(res)
            })
    }, [])

    return (
        <div>
            {!hideTitle && (
                <div className="pb-8 pt-3">
                    <h1 className="m-0 text-[24px] font-[700] leading-none tracking-[-0.03em] text-[#242529]">
                        Amazon Ads Connection
                    </h1>
                    <p className="mt-1 mb-0 text-[14px] font-[400] leading-5 text-[#777A80]">
                        Connect your Amazon Ads account to sync campaigns, reporting, and bids.
                    </p>
                </div>
            )}

            {(!hasKeys || invalidKeys) && (
                <div className="mt-8 max-w-xl">
                    <h2 className="m-0 text-[24px] font-semibold leading-tight text-[#0E2947]">
                        Connect Amazon Ads
                    </h2>
                    <p className="mt-2 mb-6 text-[15px] leading-6 text-[#7289A3]">
                        Authorize Merch Jar to access your Amazon Ads data.
                    </p>

                    {invalidKeys && (
                        <div className="mb-3 max-w-lg rounded-lg border border-[#F8D7A1] bg-[#FFF8EB] px-4 py-3 text-[14px] text-[#8A5A12]">
                            Your Amazon authorization looks invalid or revoked. Reconnect your
                            account to keep Merch Jar synced.
                        </div>
                    )}

                    <a href={link} className="inline-flex">
                        <img
                            alt="Login with Amazon"
                            className="border-none"
                            src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_156x32.png"
                            width="156"
                            height="32"
                        />
                    </a>

                    <div className="mt-1 text-[13px] text-[#94A3B8]">Secure OAuth connection</div>
                </div>
            )}

            {hasKeys && !invalidKeys && (
                <div className="mt-8 max-w-xl">
                    <div className="flex items-center gap-3">
                        <span className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#22A06B] text-white">
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                aria-hidden="true"
                            >
                                <path
                                    d="M11.5 3.75L5.75 9.5L2.5 6.25"
                                    stroke="currentColor"
                                    strokeWidth="1.8"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </span>
                        <h2 className="m-0 text-[24px] font-semibold leading-tight text-[#0E2947]">
                            Amazon Ads Connection active
                        </h2>
                    </div>
                    <p className="mt-2 mb-0 text-[15px] leading-6 text-[#7289A3]">
                        Your campaigns, reporting, and bids are synced through your secure OAuth
                        connection.
                    </p>
                </div>
            )}

            {message === 'first' && (
                <div className="mt-6 max-w-lg rounded-lg border border-[#BDE8D1] bg-[#F0FBF5] px-4 py-3 text-[14px] text-[#216B43]">
                    Your API keys have been successfully linked. Merch Jar has started pulling your
                    advertising data. This usually takes 10-30 minutes. Grab a coffee, we'll email
                    you when it's done.
                </div>
            )}
        </div>
    )
}
